/* eslint-disable @typescript-eslint/no-useless-constructor */
import { GetServerSidePropsContext, GetStaticPropsContext } from "next";
import { LayoutServiceData } from "@sitecore-jss/sitecore-jss-nextjs";
import { fetchBrightEdge } from "../../seo/bright-edge-fetcher";
import { sanitizeProps } from "../../helpers/string-helpers";

export interface BaseSitecorePageProps {
  layoutData: LayoutServiceData;
  [key: string]: unknown;
}

export interface Plugin<
  T extends BaseSitecorePageProps = BaseSitecorePageProps,
> {
  order: number;
  exec(
    props: T,
    context: GetServerSidePropsContext | GetStaticPropsContext,
  ): Promise<T>;
}

const BrightEdgePlugin: Plugin = {
  order: 5,

  async exec(
    props: BaseSitecorePageProps,
    context: GetServerSidePropsContext | GetStaticPropsContext,
  ) {
    if (context.preview) return props;

    try {
      const pageUrl = buildPageUrl(context);
      const brightEdgeData = await fetchBrightEdge(pageUrl);

      if (props.layoutData?.sitecore?.context && brightEdgeData) {
        (
          props.layoutData.sitecore.context as Record<string, unknown>
        ).brightEdge = brightEdgeData;
      }
    } catch (error) {
      console.error(
        "[BrightEdge Plugin] Error processing BrightEdge data:",
        error,
      );
    }

    return sanitizeProps(props);
  },
};

function buildPageUrl(
  context: GetServerSidePropsContext | GetStaticPropsContext,
): string {
  const path = context.params?.path
    ? `/${
        Array.isArray(context.params.path)
          ? context.params.path.join("/")
          : context.params.path
      }`
    : "/";

  const baseUrl =
    process.env.NEXT_PUBLIC_BASE_URL ?? "https://www.greystar.com";
  const url = `${baseUrl}${path}`;

  return url;
}

export const brightEdgePlugin = BrightEdgePlugin;
